const datasetNote = {
  name: "",
  disclaimer: "The data in this dataset were re-processed and shared by the Haibe-Kains Lab (University Health Network). The Haibe-Kains Lab has re-annotated the data to maximize overlap with other clinical datasets.",
  usagePolicy: "The data is under <a href='https://creativecommons.org/licenses/by/4.0/'>Creative Commons Attribution 4.0 International License</a> provided.<br />Source: <a href='https://www.ncbi.nlm.nih.gov/geo/query/acc.cgi?acc=gse15471'>https://www.ncbi.nlm.nih.gov/geo/query/acc.cgi?acc=gse15471</a>",
  citations: [
    ""
  ]
}

export default datasetNote;